export default __webpack_public_path__ + "static/media/Datorsal2.3d1a2c13.jpeg";